import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { orderCancellationRequestState } from './interfaces';
import { IOrderCancellationRequestData } from '../../../ui-toolkit/orders/interfaces/IOrderCancellationRequest';

export const orderCancellationRequestStateReducer = createSlice({
  name: 'orderCancellationRequestState',
  initialState: orderCancellationRequestState,
  reducers: {
    setCancellationRequestAction: (state, action: PayloadAction<IOrderCancellationRequestData | undefined>) => {
      state.cancellationRequest = action.payload;
    },
    setUpdateCancellationRequestFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.updateCancellationRequestFetchStatus = action.payload;
    },
    setUpdateCancellationRequestErrorAction: (state, action: PayloadAction<Error | null>) => {
      state.updateCancellationRequestError = action.payload;
    },
  },
});
export const {
  setCancellationRequestAction,
  setUpdateCancellationRequestErrorAction,
  setUpdateCancellationRequestFetchStatusAction,
} = orderCancellationRequestStateReducer.actions;
